interface Section {
    title: string;
    content?: string;
    links?: {
        label: string;
        url: string;
    }[];
    subsections?: {
        title: string;
        content: string;
        links?: {
            label: string;
            url: string;
        }[];
    }[];
}

export interface Policy {
    effective_date: string;
    contact_email: string;
    sections: Section[];
}

export const policies: Record<string, Policy> = {
    "caloric": {
        effective_date: "2025-05-17",
        contact_email: "aminoscorporation@gmail.com",
        sections: [
            {
                title: "Data Collection & Usage",
                subsections: [
                    {
                        title: "Account Information",
                        content:
                            "Caloric uses Firebase Authentication to allow users to sign up and log in using an email and password. This information is securely handled by Firebase and not stored or accessible by us. We do not collect or store email addresses, passwords, or any personally identifiable information."
                    },
                    {
                        title: "Usernames",
                        content:
                            "Users may optionally choose a username. This username is not required to contain any real personal information and is not displayed to other users. It is stored using Firebase Firestore, which handles data on our behalf. We do not control what users choose to input."
                    },
                    {
                        title: "Firebase Services",
                        content:
                            "Caloric uses Firebase Authentication, Firestore, Analytics, and Crashlytics. These services may collect usage data and other identifiers as per their privacy policies.",
                        links: [
                            {
                                label: "Firebase Privacy & Security",
                                url: "https://firebase.google.com/support/privacy"
                            },
                            {
                                label: "Firebase Analytics Policy",
                                url: "https://firebase.google.com/policies/analytics"
                            }
                        ]
                    }
                ]
            },
            {
                title: "Advertising and Analytics",
                content:
                    "Caloric is an ad-supported application using Google AdMob and Google AdSense. These services may collect certain information (e.g., device type, interactions). We do not store this information ourselves.",
                links: [
                    {
                        label: "Google Privacy Policy",
                        url: "https://policies.google.com/privacy"
                    }
                ]
            },
            {
                title: "Cookies",
                content:
                    "Caloric does not use cookies directly. However, third-party libraries and services (such as AdMob or Firebase) may use cookies or similar technologies to provide and improve their services. You may choose to accept or decline cookies via your device settings."
            },
            {
                title: "Third-Party Access",
                content:
                    "We may use third-party companies and individuals to facilitate our service, provide it on our behalf, perform service-related tasks, or analyze usage. These third parties may have access to your personal information only to perform these tasks and are obligated not to use it for other purposes."
            },
            {
                title: "External Links",
                content:
                    "Our service may contain links to other websites. If you click on a third-party link, you will be directed to that site. We do not control and are not responsible for the privacy practices of these websites."
            },
            {
                title: "Your Privacy Choices",
                content:
                    "You can manage permissions (like ad preferences or Firebase analytics data sharing) through your device settings or Google account settings."
            },
            {
                title: "Changes to This Privacy Policy",
                content:
                    "We may update this Privacy Policy from time to time. Changes are effective immediately upon posting the updated policy on this page. Please review this page periodically."
            },
            {
                title: "Contact Us",
                content:
                    "If you have any questions or suggestions about this Privacy Policy, contact us at aminoscorporation@gmail.com."
            }
        ]
    }
};
